import { render, staticRenderFns } from "./rejected-reason.vue?vue&type=template&id=5b044bf9"
import script from "./rejected-reason.vue?vue&type=script&lang=js"
export * from "./rejected-reason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports